
<div
    *ngFor="let toast of toasts; let i = index;"
    class="custom-toast"
    [ngClass]="toast.classname"
    (click)="removeToast(toast)">

    <div *ngIf="toast.hasOwnProperty('title')" class="toast-title">{{ toast.title }}</div>

    <div class="toast-body-content">
        <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
            <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>
        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </div>
</div>
